module.exports = {

    title: "Breeding Portal",

    /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
    fixedHeader: true,

    /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
    sidebarLogo: true
};



// WEBPACK FOOTER //
// ./src/settings.js